import css from 'styled-jsx/css';

const styles = css`:root {
    /* @TODO get a hold of/unify these colors...
       tell design to stop giving us a new color palatte
       with each new design...
    */

    /* New II Design Pattern - Introduced 11-12-2019 */
    /* TODO: --grey-800 is the color for primary text and should be used throughout the entire application */
}
:root {

    /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */

    /* New II Design Pattern - Introduced 11-12-2019 */
}
:root {

    /* New II Design Pattern - Introduced 11-12-2019 */
}
/* @import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css'; */
/* vertical theme */
.vertical dl {
    margin-top: calc(calc(24px / 2) / 2);
    margin-bottom: 0;
}
.vertical dt {
  font-family: 'Nimbus Sans Condensed', 'Nimbus Sans Light',
        'Nimbus Sans Con', sans-serif;
  font-style: normal;
    display: inline;
    margin: 0;
    font-size: 14px;
}
.vertical dd {
  font-family: 'Nimbus Sans Condensed', 'Nimbus Sans Light',
        'Nimbus Sans Con', sans-serif;
  font-style: normal;
    display: inline;
    margin: 0;
    font-size: 14px;
}
.vertical dd {
    font-family: 'Nimbus Sans Condensed Bold', 'Nimbus Sans Condensed',
        sans-serif;
}
.vertical dd::before,
.vertical dt::before {
    content: ' ';
}
.vertical dt::before {
    display: block;
}
/* snapshot theme */
.snapshot div {
    border-left: 1px dashed #c4c4c4;
    width: -webkit-max-content;
    width: max-content;
    display: inline-block;
    padding-right: calc(8px * 2);
    padding-left: calc(8px * 2);
    vertical-align: top;
}
.snapshot div:first-child {
    border-left: 0;
    padding-left: 0;
}
.snapshot dt {
    font-family: 'Nimbus Sans Reg', sans-serif;
    font-weight: 700;
    color: #4c5a6a;
    font-size: 14px;
    padding-bottom: 8px;
}
/* Inline Theme */
.inline .term-wrapper {
    display: inline;
    margin-right: calc(8px * 2);
}
.inline {
    margin-top: 8px;
    margin-bottom: 8px;
}
.inline dt {
    display: inline;
}
.inline dd {
    display: inline;
    margin: 0;
    font-weight: bold;
}
/* Landing Theme */
.landing .term-wrapper {
    display: inline;
    margin-right: 8px;
    border-left: 1px solid #56646b;
    padding-left: 8px;
    line-height: 22px;
    font-family: 'Nimbus Sans';
    font-weight: normal;
    white-space: nowrap;
}
.landing .term-wrapper:first-child {
    border-left: 0;
    padding-left: 0;
}
.landing {
    margin-bottom: 10px;
    font-size: 16px;
    color: #3b3b3b;
    min-height: calc(8px * 3);
}
.landing dt {
    display: inline;
}
.landing dd {
    display: inline;
    margin: 0;
    font-weight: normal;
}
.landing dt,
.landing dd {
    white-space: normal;
    word-break: break-word;
}
@media (max-width: 720px) {
    dl.inline {
        display: flex;
        flex-direction: column;
    }

    dl.inline .term-wrapper {
        display: flex;
    }

    dl.inline .term-wrapper dd {
        margin-left: 6%;
    }
}
@media (max-width: 1080px) {
    /* Landing Mobile Theme */
    .landing .term-wrapper {
        display: block;
        margin-right: 8px;
        border: none;
        padding-left: 0;
    }
}
`;

export default styles;